import { render, staticRenderFns } from "./BgSelectRelationModal.vue?vue&type=template&id=e825e7d2"
import script from "./BgSelectRelationModal.vue?vue&type=script&lang=js"
export * from "./BgSelectRelationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports